export const LOGIN = 'user/authenticate';
export const BANNIERES = 'par/banniere';
export const DIVISIONS = 'inv/division';
export const DEPARTEMENTS = 'inv/departement';
export const ACHETEURS = 'par/usager';
export const CATEGORIES = 'inv/categorie';
export const FOURNISSEURS = 'cap/fournisseur';
export const PRODUITS = 'approbweb/produit';
export const STATS_FOURNISSEURS = 'approbweb/fournisseur';
export const STATS_DIVISIONS = 'approbweb/division';
export const TACHES = 'approbweb/tache';
export const ROLES = 'approbweb/document/role';
export const ACTIVITES = 'inv/activite';
export const STATS_ACTIVITES = 'approbweb/activite';